// extracted by mini-css-extract-plugin
export default {"TabsSubgroups":"TabsSubgroups__TabsSubgroups___r75Aw","open":"TabsSubgroups__open___t92dA","inner":"TabsSubgroups__inner___bDNfn"};